import * as React from 'react';
const BrtIcon = props => {
  const fill = props.color ? props.color : '#fff';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="spedizionieri_icon"
      data-name="spedizionieri icon"
      viewBox="0 0 242.96 209.3"
      {...props}
    >
      <defs>
        <style>{`.brt-icon{fill:${fill};fill-rule:evenodd}`}</style>
      </defs>
      <path
        d="M242.96 209.3H0V0h242.96v209.3ZM8.67 200.8h225.62V8.67H8.67V200.8Z"
        className="brt-icon"
      />
      <path
        d="M57.98 121.57v10.2c0 4.76-2.89 4.59-2.89 4.59H44.38v-17.85h10.54c1.53-.17 2.89.85 3.06 2.38v.68M44.21 76.68h10.71c1.36-.17 2.72.85 2.89 2.21v11.9c.17 1.53-1.02 2.89-2.55 3.06H44.21V76.68Zm12.24-24.65H25v104.56h37.75a18.46 18.46 0 0 0 16.15-18.7v-19.21c.17-7.65-6.12-14.11-13.77-14.11h-.51c13.43-2.04 14.28-9.01 14.28-15.13V71.59c.68-10.03-6.97-18.87-17-19.55h-5.44ZM159.82 74.98h19.56v82.46h20.06V74.13h18.87V52.71h-58.49v22.27zM146.39 89.26V71.58c.68-10.03-6.97-18.87-17-19.55H92.32v104.56h19.38v-38.26h10.54c1.53-.17 2.89.85 3.06 2.38v35.71h20.74v-38.09c0-12.75-13.43-14.62-15.13-14.28 13.6-1.87 15.3-8.84 15.47-14.79Zm-20.91 1.7c.17 1.53-1.02 2.89-2.55 3.06h-11.05v-17h10.71c1.36-.17 2.72.85 2.89 2.21v11.73Z"
        className="brt-icon"
      />
    </svg>
  );
};
export default BrtIcon;
